import React from 'react';
import { BookOpenIcon } from 'lucide-react';
type CoverPendingProps = {
  title: string;
  compact?: boolean;
};
/** Segnaposto tipografico finché la proprietaria non fornisce la copertina reale. */
export function CoverPending({
  title,
  compact = false
}: CoverPendingProps) {
  if (compact) {
    return <div className="flex h-full w-full items-center justify-center bg-lilac text-plum" data-id="element-44" data-mp="1ttt3adaivq2z">
        <BookOpenIcon size={22} aria-hidden="true" data-id="element-45" data-mp="28qtpy2duwuul" />
      </div>;
  }
  return <div className="flex h-full w-full flex-col items-center justify-center gap-4 bg-lilac p-10 text-center" data-id="element-46" data-mp="23s9zpps8cwwf">
      <BookOpenIcon size={32} aria-hidden="true" className="text-berry-deep" data-id="element-47" data-mp="2hjf4t7edahe5" />
      <p className="max-w-[16rem] font-serif text-2xl font-semibold leading-snug text-plum" data-id="element-48" data-mp="2hlhshks1ryfp">{title}</p>
      <p className="text-sm text-ink/70" data-id="element-49" data-mp="2dkfrozihfebm">Copertina in arrivo</p>
    </div>;
}